export default {
  bolsaComerciales: {
    menuItem: "Commercial wallet",
    pageTitle: "Commercial wallet",
    dashboardMenu: "Dashboard",
    settingsMenu: "Settings",
    settingsTitle: "Settings",
    settingsAdminOnly: "Only a system administrator can manage these roles.",
    walletsTab: "Wallets",
    commercialsTab: "Commercials",
    historyTab: "History",
    hiddenTab: "Hidden",
    hideSelected: "Hide",
    unhideSelected: "Unhide",
    noHiddenMovements: "No hidden movements.",
    hideRequiresShipping: "Only movements with a shipping can be hidden.",
    hideDone: "Movements hidden",
    unhideDone: "Movements restored",
    myWalletTab: "My wallet",
    commercialsConfigTitle: "Commercial users",
    initialBalance: "Initial balance",
    currentBalance: "Current balance",
    balanceAfter: "Balance after",
    movements: "Movements",
    inject: "Inject funds",
    injectTitle: "Inject USD balance",
    myWallet: "My wallet",
    myWalletIfCommercial: "My wallet (if configured)",
    noWallets: "No wallets configured yet.",
    noUsers: "No users available.",
    noWalletForUser: "You do not have an active commercial wallet.",
    noMovements: "No movements yet.",
    noHistory: "No movements from closed operations.",
    accessDenied: "You do not have access to this module.",
    loadError: "Could not load commercial wallet data.",
    invalidAmount: "Enter a valid amount greater than zero.",
    searchUsers: "Search user…",
    historySearchPlaceholder: "Search by concept, contact or shipping…",
    historyApply: "Search",
    historyCommercialFilter: "Commercial",
    historyAllCommercials: "All commercials",
    historyPage: "Page",
    historyOf: "of",
    bolsaRole: "Role",
    roleNone: "No role",
    roleManager: "Wallet manager",
    roleViewer: "Viewer",
    openProformNewTab: "Open proforma in new tab",
    selectedColumns: "{count} selected columns",
    columnTt: "TT",
    columnCurrency: "Currency",
    columnUsdAmount: "In USD",
    columnShipper: "Shipper",
    columnOperationalInCharge: "Operational in charge",
    customizeDisplay: "Customize display",
    details: "Details",
    invoices: "Invoice",
    bankPaymentDate: "Bank payment date",
    etaFrom: "ETA from",
    etaTo: "ETA to",
    etaSortDefault: "Sort by movement date",
    etaSortNearest: "Nearest ETA first",
    etaSortFarthest: "Farthest ETA first",
    amountTotal: "Amount total",
    viewAmountBreakdown: "View total breakdown",
    amountBreakdown: "Total",
    appliedTotal: "Applied total",
    viewAppliedBreakdown: "View applied total breakdown",
    subtotalColumn: "Subtotal (USD)",
    compositionAdds: "Adds",
    compositionSubtracts: "Subtracts",
    subtotalsByExpense: "By expense",
    subtotalsByType: "Subtotals by type",
    subtotalsByShipping: "Subtotals by shipping",
    movementCount: "{count} movements",
    clientCommercialTooltip: "Customer's commercial",
    supplierCommercialTooltip: "Supplier's commercial",
    bothCommercialTooltip: "Customer's and supplier's commercial",
    movementType: {
      initial: "Initial balance",
      adjustment: "Admin injection",
      payment: "Payment",
      collect: "Collect",
      invoice: "Invoice",
      invoiceClient: "Invoice client",
      invoiceSupplier: "Invoice supplier",
      expense: "Shipping expense",
      nota_comercial: "Commercial note",
      nota_comercial_debit: "Commercial debit note",
      reversal: "Reversal",
    },
  },
};
